module.exports = __webpack_public_path__ + "media/02 honor.15de7d9a.mp3";